import { render, staticRenderFns } from "./mem_text.vue?vue&type=template&id=684249e7&scoped=true&"
import script from "./mem_text.vue?vue&type=script&lang=js&"
export * from "./mem_text.vue?vue&type=script&lang=js&"
import style0 from "./mem_text.vue?vue&type=style&index=0&id=684249e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684249e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684249e7')) {
      api.createRecord('684249e7', component.options)
    } else {
      api.reload('684249e7', component.options)
    }
    module.hot.accept("./mem_text.vue?vue&type=template&id=684249e7&scoped=true&", function () {
      api.rerender('684249e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/sides/helpers/mem_text.vue"
export default component.exports